import React from 'react';
import styled from 'styled-components';
import MultiSelect from '../../components/MultiSelect';
import NextButton from '../../components/NextButton';
import HappyIcon from '../../assets/happy';

const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
`;
const Heading = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: white;
`;
const SubHeading = styled.span`
  font-size: 24px;
  color: white;
`;
const Text = styled.span`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.7);
`;
const Bottom = styled.div`
  margin-top: 60px;
`;

const AddMoreMindfulness2 = () => {
  return (
    <Container>
      <HappyIcon width={56} height={56} />
      <Heading style={{ marginTop: 40 }}>
        Mindfulness takes many forms. Whether it’s meditation, prayer, journaling, or something else, taking a few
        minutes for yourself can reset the tone for your day.
      </Heading>

      <SubHeading>Just a minute to start</SubHeading>

      <Text>Choose as many as you like</Text>

      <Bottom>
        <NextButton>Continue</NextButton>
      </Bottom>
    </Container>
  );
};

export default AddMoreMindfulness2;
